export const brandFunnelMetricEndPoint = `brand-funnel-metrics`;
export const questionnaireEndPoint = 'questionnaire';
